import { useNavigate } from "react-router-dom";

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-ink"><div className="max-w-3xl mx-auto px-6 py-24 pt-36 text-muted leading-relaxed">
      <h1 className="font-display text-[clamp(36px,6vw,64px)] leading-none tracking-wide text-paper mb-6">Cookie Policy for Deep-c Vision</h1>
      <p><strong>Effective Date:</strong> 30 June 2025</p>

      <p className="mt-4">
        This Cookie Policy explains how Deep-c Vision uses cookies and similar technologies on our website{" "}
        <a href="https://deepcvision.co.uk" className="text-brand-cyan hover:underline" target="_blank" rel="noopener noreferrer">
          https://deepcvision.co.uk
        </a>.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">1. What Are Cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. They help enhance user experience,
        analyze website performance, and provide functionality like remembering your preferences.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">2. Types of Cookies We Use</h2>
      <ul className="list-disc pl-6">
        <li><strong>Essential Cookies:</strong> Necessary for the site to function properly.</li>
        <li><strong>Performance Cookies:</strong> Help us understand how visitors interact with our website (e.g., Google Analytics).</li>
        <li><strong>Functionality Cookies:</strong> Remember your preferences and settings.</li>
        <li><strong>Marketing Cookies:</strong> May be used to deliver relevant advertising, if applicable.</li>
      </ul>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">3. Managing Cookies</h2>
      <p>
        You can control and manage cookies through your browser settings. You can choose to block or delete cookies,
        but some features of the website may not work properly.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">4. Third-Party Cookies</h2>
      <p>
        We may allow trusted third parties to set cookies (e.g., analytics or embedded content providers).
        We do not control these cookies; please refer to their privacy and cookie policies.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">5. Changes to This Policy</h2>
      <p>
        We may update this Cookie Policy. Changes will be posted on this page with an updated effective date.
      </p>

      <h2 className="font-display text-[26px] tracking-wide text-paper mt-12 mb-3">6. Contact Us</h2>
      <p>
        If you have any questions, please contact us at:<br />
        <strong>Email:</strong>{" "}
        <a href="mailto:contact@deepcvision.co.uk" className="text-brand-cyan hover:underline">
          contact@deepcvision.co.uk
        </a>
      </p>

      <button
        onClick={() => navigate(-1)}
        className="bg-primary-purple text-white text-sm font-semibold mt-10  px-4 py-3 rounded-btn z-50"
      >
        ← Back
      </button>
    </div></div>
  );
};

export default CookiePolicy;
